import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ADUser } from '../../model/ADUser'
import { ADService } from '../../service/ad.service';
import { DxListComponent } from 'devextreme-angular';

@Component({
  selector: 'ad-user',
  templateUrl: './ad-user.component.html',
  styleUrls: ['./ad-user.component.scss']
})

export class ADUserComponent {
  @ViewChild(DxListComponent, { static: false }) dataList: DxListComponent;
  @Input() adUserSearchVisible: boolean;
  @Input() elementId: string;
  @Output() searchResult = new EventEmitter<ADUser>();
  positionId: string;
  searchHint: string = '';
  searchButtonOptions: any;
  closeButtonOptions: any;
  isToastVisible: boolean = false;
  toastMessage: string = '';
  isNotValid: boolean = false;
  selectAllModeVlaue = 'page';
  selectionModeValue = 'all';
  adUsers: ADUser[] = [];
  type = 'success';
  constructor(private adService: ADService) {
    this.positionId = `#${this.elementId}`
  }

  searchUsers(form: NgForm) {
    if (this.searchHint.length < 2) {
      this.isNotValid = true;
      return;
    }
    
    this.adService.searchUsers(this.searchHint)
      .subscribe(
        (data: ADUser[]) => {
          this.adUsers = data;
          this.isToastVisible = true;
          this.toastMessage = `Number of AD users found ${data.length}.`
        }
      );

    this.isNotValid = false;
  }

  apply() {
    if (!this.dataList.selectedItems) return;
    this.searchResult.emit(this.dataList.selectedItems[0]);
    this.searchHint = '';
    this.adUsers = [];
    this.adUserSearchVisible = false;
  }

  closeDialog() {
    this.adUserSearchVisible = false;
    var adUser = new ADUser();
    this.searchResult.emit(adUser);
    this.isNotValid = false;
    this.adUsers = [];
    this.searchHint = '';
  }

}
